export { default } from './ItemList';



// WEBPACK FOOTER //
// ./app/components/shared/ItemList/index.js